import Dialog from 'quasar/src/plugins/Dialog.js';;

interface ModalApi {
  onOk(cb: (payload?: any) => void): ModalApi;
  onCancel(cb: () => void): ModalApi;
  onDismiss(cb: () => void): ModalApi;
  hide(): void;
}

export default function openModal(component: object, config: Record<string, any> = {}): ModalApi {
  const componentProps = { ...config };
  delete componentProps.parent;

  return Dialog.create({
    component,
    componentProps,
  });
}
